













import { format as formatDate } from 'date-fns';
import { Vue, Prop, Component } from 'vue-property-decorator';

import { DetailsInterface } from '@/interfaces/interfaces';

@Component
export default class RegistrationInfo extends Vue {
  @Prop() private details!: DetailsInterface;

  get startDate() {
    return formatDate(this.details.startDate, 'ddd, MMMM DD YYYY');
  }
}
